import { inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormTemplate } from '@app/core/classes/form-template';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

const dateForTimeDisplay = moment('1900-01-01T14:00:00Z');

export abstract class WidgetConfigFormTemplate extends FormTemplate {
  protected form: FormGroup;
  protected fb = inject(FormBuilder);
  protected translate = inject(TranslateService);

  protected timeFormatShort = this.translate.instant('FORMAT.TIME-ONLY');
  protected timeFormat24h = this.translate.instant('FORMAT.TIME-ONLY-24HR');
  protected timeFormatShortSample = dateForTimeDisplay.format(this.timeFormatShort);
  protected timeFormat24hSample = dateForTimeDisplay.format(this.timeFormat24h);
}
